<template>
  <div id="app">
    <Nav>
      <Burger/>
      <Bio />
      <Menu/>
      <Sidebar full-name="Luchian Emil"/>
    </Nav>
    <CVShort/>
    <ShortContent/>
    <CVLong/>
    <LongContent/>
  </div>
</template>

<script>
  import Burger from "./Menus/Burger";
  import Menu from "./Menus/Menu";
  import Nav from "./Nav";
  import Bio from "./Menus/Bio";
  import Sidebar from "./Menus/Sidebar";
  import CVShort from "./CV-Short";
  import CVLong from "./CV-LongContent/CV-Long";
  import ShortContent from "./CV-Short-Content";
  import LongContent from "./CV-LongContent/CV-Long-Content"

  export default {
    name: "app",
    components: {Burger, Menu, Nav, Bio, Sidebar, CVShort,
    CVLong, ShortContent, LongContent}
  };
</script>

<style>

</style>
